import { useMIDs } from '@entities/mid';
import type { IMIDTableColumns } from '@entities/mid';
import ModalOpenBtn from '@features/modal-open-btn';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import {
  Table,
  TBody,
  THead,
  TableActions,
  TableActionsItem,
  TableContainer,
  TableProvider,
} from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const SettingsMIDsPage = () => {
  const {
    mids,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useMIDs();

  const { columnTitles, renderRow, NewMID } = useTableSettings({
    refetch,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (mids) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<IMIDTableColumns> columnTitles={columnTitles} {...filter}>
          <TableActions>
            <TableActionsItem>
              <ModalOpenBtn text='New' modalContent={<NewMID />} />
            </TableActionsItem>
          </TableActions>

          <TableContainer>
            <Table>
              <THead />
              <TBody items={mids.data} renderItem={renderRow} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={mids.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default SettingsMIDsPage;
